import Vue from 'vue'
import Router from 'vue-router'
import adminRouter from './adminRouter'
import {
  base,
  receptionRouter
} from './receptionRouter'
const FinalRouter = receptionRouter.concat(adminRouter);
let route = [];
//一级路由
let item_first = {};
//二级路由
let item_second = {};
//三级路由
let item_third = {};
//四级路由
let item_four = {};
FinalRouter.map(k => {
  // console.log(k);
  item_first = {
    path: `${base}${k.path}`,
    name:k.name,
    component: () => import(`../pages${k.url}.vue`),
    meta: {
      title: k.name
    }
  }
  //如果二级路由则添加
  if (k.child) {
    console.log("有二级");
    item_first.children = [];
    k.child.map(j => {
      item_second = {
        path: `${base}${j.path}`,
        name:j.name,
        component: () => import(`../pages${j.url}.vue`),
        meta: {
          title: j.name
        }
      }
      //如果三级路由则添加
      if (j.child) {
        console.log("有三级");
        item_second.children = [];
        j.child.map(z => {
          item_third = {
            path: `${base}${z.path}`,
            name:z.name,
            component: () => import(`../pages${z.url}.vue`),
            meta: {
              title: z.name
            }
          }
           //如果四级路由则添加
          if (z.child) {
            console.log("有四级");
            item_third.children = [];
            z.child.map(x => {
              item_four = {
                path: `${base}${x.path}`,
                name:x.name,
                component: () => import(`../pages${x.url}.vue`),
                meta: {
                  title: x.name
                }
              }
              item_third.children.push(item_four);
            })
          }
            item_second.children.push(item_third);
        })
      }
      item_first.children.push(item_second);
    })
  }
  return route.push(item_first)
})

route.push({
  path: "*",
  component: () => import('../pages/pageNotFount.vue'),
  meta: {
    title: "页面找不到了"
  }
})
const Routers = new Router({
  mode: 'hash',
  routes: route
});
// console.log(route);
/**
 * 只支持四级路由, { child:[{child}]}嵌套
 *  name: "",
    path: 'ip后面全路径',
    url: '', pages下面的文件相对路径
 */
Vue.use(Router)
export default Routers



// WEBPACK FOOTER //
// ./src/router/finalRouter.js